import { QueryType } from "../query/types";

/**
 * Query types a general model can be defined with, before filtering against the
 * source's supported queries.
 *
 * Kept outside lib/query/ so a change here does not require every warehouse E2E
 * suite: .circleci/src/warehouse_test_selection.ts treats that directory as a
 * shared dialect surface, and this list cannot change the SQL a dialect receives.
 */
export const GENERAL_MODEL_QUERY_TYPES: readonly QueryType[] = [
  QueryType.Table,
  QueryType.RawSql,
  QueryType.DbtModel,
  QueryType.DbtCloudModel,
];
